import { useEffect } from 'react';
import { NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useLocation } from 'react-router-dom';
import { useFeatureIsOn } from 'src/common/growthbook';
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;
const GOOGLE_ONE_TAP_FEATURE_FLAG_NAME = 'google-1-tap';
const SHOW_ON_PATHS = new Set(['/']);
export const GoogleOneTap = () => {
  const featureFlag = useFeatureIsOn(GOOGLE_ONE_TAP_FEATURE_FLAG_NAME);
  const location = useLocation();
  const isOneTapPage = SHOW_ON_PATHS.has(location.pathname);
  useEffect(() => {
    if (featureFlag && GOOGLE_CLIENT_ID && window.google?.accounts?.id && isOneTapPage) {
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: response => {
          if (response.credential) {
            NotificationDispatch('info', 'Google One Tap is coming soon. For now, please use google sign in or email sign in.');
          }
        },
        cancel_on_tap_outside: false
      });
      window.google.accounts.id.prompt();
    }
    return () => {
      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel();
      }
    };
  }, [featureFlag, isOneTapPage]);
  return <div id="google-one-tap-container" style={{
    position: 'fixed',
    top: 0,
    right: 0,
    zIndex: 9999
  }} data-sentry-component="GoogleOneTap" data-sentry-source-file="google-one-tap.tsx" />;
};